export enum ActionButtonType {
  Ban = "ban",
  Verify = "verify",
  Feature = "feature",
}
